import { useEffect, useRef } from 'react'
import { useAuth } from '../hooks/useAuth'
import { useClerk } from '@clerk/react'
import { useT } from '../i18n'

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth()
  const { openSignIn } = useClerk()
  const t = useT()

  const everAuthenticated = useRef(false)
  if (isAuthenticated) everAuthenticated.current = true

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !everAuthenticated.current) {
      openSignIn()
    }
  }, [isLoading, isAuthenticated, openSignIn])

  if (isLoading && !everAuthenticated.current) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-[13px] text-[var(--text-3)] font-[family-name:var(--font-mono)]">
          {t('common.loading')}
        </div>
      </div>
    )
  }

  if (!isAuthenticated && !everAuthenticated.current) {
    return <div className="h-screen bg-[var(--bg)]" />
  }

  return <>{children}</>
}
